// extracted by mini-css-extract-plugin
var _1 = "RemoveAddressModal_buttonsContainer__6RVQy";
var _2 = "RemoveAddressModal_container__8kY91";
export { _1 as "buttonsContainer", _2 as "container" }
